// extracted by mini-css-extract-plugin
export default {"zoomImageWrapper":"style_zoomImageWrapper__jSULd","zoomControl":"style_zoomControl__lveqF","imageContainer":"style_imageContainer__Yp+pQ","zoomedImage":"style_zoomedImage__Irm2I"};